import React from "react";
import PublicHeader from "../../Layouts/PublicRouteLayouts/PublicHeader";
import PublicFooter from "../../Layouts/PublicRouteLayouts/PublicFooter";
import PrivateHeader from "../../Layouts/PrivateRouteLayouts/PrivateHeader";

export default function PublicRoute({ children }) {
  const urexperttoken = localStorage.getItem("urexperttoken");
  return (
    <div>
      {urexperttoken && urexperttoken?.length > 15 ? (
        <PrivateHeader />
      ) : (
        <PublicHeader />
      )}

      {children}
      <PublicFooter />
    </div>
  );
}
